class TokenService {
  getLocalRefreshToken() {
    const tokens = JSON.parse(localStorage.getItem("cabtifyPassengerTokens"));
    return tokens?.refresh.token;
  }

  getLocalAccessToken() {
    const tokens = JSON.parse(localStorage.getItem("cabtifyPassengerTokens"));
    return tokens?.access.token;
  }

  updateLocalAccessToken(token) {
    let tokens = JSON.parse(localStorage.getItem("cabtifyPassengerTokens"));
    tokens.access = token;
    localStorage.setItem("cabtifyPassengerTokens", JSON.stringify(tokens));
  }

  getUser() {
    return JSON.parse(localStorage.getItem("cabtifyPassengerTokens"));
  }
}

export default new TokenService();
